import "./Loginn.css";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { loginUser } from "../../firebase/auth";
import { isAdmin } from "../../services/adminService";

import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../../firebase/config";

import { signOut } from "firebase/auth";
import loginpageimage2 from "../../assets/images/loginpageimage2.png";
// import logoo from "../../assets/images/gymfithorlogo2-removebg-preview.png";
import logoo from "../../assets/images/gymfitorangelogo22.png";

import { FaEnvelope, FaLock } from "react-icons/fa";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { updateDoc } from "firebase/firestore";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Email Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      alert("Please enter your email address.");
      return;
    }

    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Password Validation
    if (!password.trim()) {
      alert("Please enter your password.");
      return;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#!])[A-Za-z\d@$!%*?&#!]{8,}$/;

    if (!passwordRegex.test(password)) {
      alert(
        "Password must be at least 8 characters and include uppercase, lowercase, number and special character.",
      );
      return;
    }

    try {
      await loginUser(email, password);

      const user = auth.currentUser;

      await user.reload();

      const admin = await isAdmin();
      console.log("Current UID:", auth.currentUser.uid);
      console.log("Is Admin:", admin);

      // Super Admin Login
      if (admin) {
        console.log("Navigating to admin...");
        navigate("/admin");
        return;
      }

      // Gym Admin Email Verification
      if (!user.emailVerified) {
        await signOut(auth);

        navigate("/verify-email");

        return;
      }

      const uid = auth.currentUser.uid;

      const gymDoc = await getDoc(doc(db, "gyms", uid));

      if (!gymDoc.exists()) {
        alert("Gym data not found");
        return;
      }

      const gym = gymDoc.data();
      await updateDoc(doc(db, "gyms", uid), {
        lastLogin: new Date().toISOString(),
        emailVerified: user.emailVerified,
      });

      // Pending Approval
      if (gym.status === "Pending") {
        navigate("/pending-approval");
        return;
      }

      // Paid users must purchase a plan first
      if (
        gym.registrationType === "paid" &&
        gym.subscriptionStatus !== "Active"
      ) {
        navigate("/subscription");
        return;
      }

      // Rejected
      if (gym.status === "Rejected") {
        alert("Your gym registration was rejected by admin.");
        return;
      }

      // Subscription Expired
      if (gym.subscriptionEndDate) {
        const today = new Date();
        const expiry = new Date(gym.subscriptionEndDate);

        if (today > expiry) {
          navigate("/subscription-expired");
          return;
        }
      }

      navigate("/dashboard");
    } catch (error) {
      console.error(error);
      alert("Invalid Email or Password");
    }
  };

  return (
    <div className="login-page">
      <div
        className="hero-section"
        style={{
          backgroundImage: `url(${loginpageimage2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h1>Manage Your Gym Efficiently</h1>

          <p>Track Members, Attendance, Trainers and Payments in one place.</p>

          <div className="hero-buttons">
            <button>Gym Management</button>

            <Link to="/">
              <button>Landing Page</button>
            </Link>
          </div>
        </div>
      </div>

      <div className="login-section">
        <div className="login-card">
          <div className="logo-box">
            <img src={logoo} alt="logo" className="logocss" />
            {/* <p className="logopara">Smart Gym & Fitness Management Software</p> */}
          </div>

          <h2>Welcome Back</h2>

          <p className="subtitle">Sign in to access your dashboard</p>

          <form onSubmit={handleSubmit}>
            <label>Email Address</label>

            <div className="input-group">
              <FaEnvelope className="input-icon" />

              <input
                type="email"
                placeholder="owner@gym.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="password-row">
              <label>Password</label>

              <Link to="/forgot-password">Forgot Password?</Link>
            </div>

            <div className="input-group">
              <FaLock className="input-icon" />

              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" className="login-btn">
              Sign In
            </button>
          </form>

          <p className="register-link">
            Don't have an account?
            <Link to="/register"> Register</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
